export const GET_USERS_PREFERENCE_REQUEST = " GET_USERS_PREFERENCE_REQUEST";
export const GET_USERS_PREFERENCE_SUCCESS = " GET_USERS_PREFERENCE_SUCCESS";
export const GET_USERS_PREFERENCE_FAILURE = " GET_USERS_PREFERENCE_FAILURE";
